import React from "react";

const Close = ({ size = 17, ...rest }) => {
    return (
        <svg
        width={size}
        height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <g id="x-close">
                <path
                    id="Icon"
                    d="M18 6L12 12M12 12L6 18M12 12L6 6M12 12L18 18"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    );
};

export default Close;
